// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bddad90d","409":"1104ef32"}[chunkId] + ".chunk.js";
};